var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalendarIcon = function SvgCalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#56565A",
    d: "M11.333 2H14a.667.667 0 0 1 .666.667v10.666A.667.667 0 0 1 14 14H2a.667.667 0 0 1-.667-.667V2.667A.667.667 0 0 1 2 2h2.666V.667H6V2h4V.667h1.333V2m2 5.333H2.666v5.334h10.667V7.333Zm-3.333-4H6v1.334H4.666V3.333h-2V6h10.667V3.333h-2v1.334H10V3.333ZM4 8.667h1.333V10H4V8.667m3.333 0h1.333V10H7.333V8.667m3.333 0H12V10h-1.334V8.667"
  })));
};
export default SvgCalendarIcon;